export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" fill="none">
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M28.71 0H2.29A2.292 2.292 0 0 0 0 2.293v27.415A2.292 2.292 0 0 0 2.29 32h26.42A2.291 2.291 0 0 0 31 29.708V2.293A2.292 2.292 0 0 0 28.71 0ZM9.396 26.787H4.715v-14.45h4.682v14.45ZM7.056 10.365h-.03c-1.572 0-2.588-1.11-2.588-2.496 0-1.418 1.047-2.497 2.648-2.497 1.602 0 2.588 1.079 2.619 2.497 0 1.386-1.017 2.496-2.65 2.496ZM26.28 26.787H21.6v-7.73c0-1.942-.678-3.267-2.373-3.267-1.293 0-2.063.893-2.402 1.756-.124.309-.154.74-.154 1.172v8.07h-4.683s.062-13.095 0-14.45h4.683v2.046C17.29 13.4 18.404 12 20.89 12c3.08 0 5.39 2.065 5.39 6.503v8.285Z"
      />
    </g>

    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h31v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
